// Mirrors backend varchar caps on the users table — keep in sync with
// backend/shared/pydantic_schemas/user.py and backend/shared/constants/pydantic_types.py.
export const USER_FIELD_MAX_LENGTHS = {
  phone_number: 20,
  first_name: 40,
  last_name: 40,
  email: 255,
  email_cadence: 255,
  address1: 80,
  address2: 80,
  city: 40,
  state: 40,
  zipcode: 10,
  country: 2, // CountryAlpha2 (ISO 3166-1 alpha-2)
  employer: 128,
  occupation: 64,
  employer_address1: 80,
  employer_address2: 80,
  employer_city: 40,
  employer_state: 40,
  employer_zipcode: 10,
  employer_country: 2,
  ref_code: 40,
} as const;
